import MuiButton from "@mui/material/Button";
import { MouseEvent } from "react";
import styles from "./Button.module.scss";

import { getButtonStyles } from "./Button.styles";

export interface ButtonProps {
  onClick: (event?: MouseEvent<HTMLElement>) => void;
  label: string | JSX.Element;
  variant: "text" | "outlined" | "contained";
  color: "primary" | "secondary";
  mobile?: boolean;
  textAlignment?: "left" | "center" | "right";
  icon?: string;
  underline?: boolean;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  maxWidth?: boolean;
  form?: string;
  iconLocation?: "left" | "right";
}

function Button(props: ButtonProps) {
  const {
    onClick,
    label,
    type,
    disabled,
    variant,
    color,
    mobile,
    textAlignment,
    icon,
    underline,
    maxWidth,
    form,
    iconLocation = "left",
  } = props;

  const buttonStyles = getButtonStyles(color, variant);

  const hadleOnClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onClick();
  };

  return (
    <MuiButton
      className={`${styles.buttonComponent} ${
        mobile ? styles.buttonMobile : ""
      }`}
      onClick={hadleOnClick}
      disabled={disabled}
      type={type || "button"}
      variant={variant}
      color={color}
      sx={{
        ...buttonStyles,
        justifyContent: textAlignment || "center",
        textDecoration: underline ? "underline" : "none",
        width: maxWidth ? "100%" : "fit-content",
      }}
      disableRipple
      form={form}
    >
      {icon && iconLocation === "left" ? (
        <i className={`${icon} ${styles.buttonIcon}`} />
      ) : null}
      {typeof label === "string" ? (
        <p className={`${styles.buttonLabel} body-bold-medium`}>{label}</p>
      ) : (
        label
      )}
      {icon && iconLocation === "right" ? (
        <i className={`${icon} ${styles.buttonIcon}`} />
      ) : null}
    </MuiButton>
  );
}

export default Button;
